export default {
  app: {
    contact: {
      contacts: 'Kontakty',
      pageTitle: 'Elixír Tours - kontakt',
    },
  },
};
